import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import "./styles/globals.css";
import { BUILD_MARKER } from "@/lib/build-marker";
import { ensureLanguage, storedLanguage } from "@/i18n";
import { queryClient } from "@/lib/query-client";
import { restorePersistedQueries, startQueryPersistence } from "@/lib/query-persist";
import { markStartup } from "@/lib/startup-perf";

console.info("Fad Agency OS build:", BUILD_MARKER);

markStartup("react-bootstrap");

// Refill the query cache from the last session BEFORE the first render, so
// every page the user already visited paints instantly with its last-known
// data (then revalidates in the background). Wiped on logout / terminal 401.
restorePersistedQueries(queryClient);
startQueryPersistence(queryClient);

function mount(): void {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// Only French is bundled in the startup chunk. If the user persisted English or
// Arabic, fetch that bundle BEFORE the first render — the static shell from
// index.html is already on screen and is language-neutral, so this costs no
// blank frame and avoids a flash of French. French users pay nothing.
const lang = storedLanguage();
if (lang === "fr") {
  mount();
} else {
  void ensureLanguage(lang).then(mount);
}
